import { isEmpty } from 'lodash';
import React from 'react';
import { FieldSwitcherRowProps } from '../../../Agenda.types';
import { useAgendaTemplatesContext } from '../../../hooks/agendaTemplateView.hook';
import Switcher from '../../Switcher.component';
import styles from './TemplateModal.module.scss';

export default function FieldSwitcherRow({
  field,
}: FieldSwitcherRowProps): React.ReactElement {
  const { currentTemplateFields, setCurrentTemplateFields } =
    useAgendaTemplatesContext();

  const isOn = !isEmpty(currentTemplateFields?.[field?.name]);

  return (
    <div className={styles.FieldSwitcherRow}>
      <p className={styles.FieldSwitcherRow__Name}>{field.nameTag}</p>
      <Switcher
        className={styles.FieldSwitcherRow__Switcher}
        reverse
        invertColors
        on={isOn}
        changeHandler={() =>
          isOn
            ? setCurrentTemplateFields({
                ...currentTemplateFields,
                [field.name]: null,
              })
            : setCurrentTemplateFields({
                ...currentTemplateFields,
                [field.name]: field,
              })
        }
      />
    </div>
  );
}
